import { Link } from '@change-corgi/design-system/components/actions';
import { Box } from '@change-corgi/design-system/layout';

import { JoinTheCommunity } from './components/JoinTheCommunity';
import { usePageFooter } from './hooks/usePageFooter';

export function PageFooter() {
	const {
		data: { skipLabel, skipUrl },
		actions: { handleSkipClick },
	} = usePageFooter();

	return (
		<Box mt={32} sx={{ textAlign: 'center' }}>
			<JoinTheCommunity mt={60} mb={32} />
			<Link to={skipUrl} onClick={handleSkipClick} data-qa="skip-link">
				{skipLabel}
			</Link>
		</Box>
	);
}
